/* Smarty theme – vanilla JS, no dependencies */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  var T = window.theme || { routes: {}, strings: {} };
  var isRTL = document.documentElement.dir === 'rtl';

  /* ---------- helpers ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-visible');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }
  function rootUrl(path) { return (T.routes.root || '/').replace(/\/$/, '') + path; }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
    setTimeout(function () { try { d.focus({ preventScroll: true }); } catch (e) { d.focus(); } }, 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    $$('.filters.is-open').forEach(function (f) { f.classList.remove('is-open'); });
    document.body.classList.remove('is-locked');
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawers(); return; }
    var c = e.target.closest('.js-cart-open');
    if (c && T.cartType === 'drawer' && document.getElementById('CartDrawer') && document.body.className.indexOf('template-cart') === -1) {
      e.preventDefault(); openDrawer('CartDrawer'); return;
    }
    var ft = e.target.closest('[data-filters-toggle]');
    if (ft) { var f = $('#Filters'); if (f) { f.classList.toggle('is-open'); document.body.classList.toggle('is-locked', f.classList.contains('is-open')); } return; }
    if (e.target.id === 'Filters') { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- categories dropdown (touch) ---------- */
  $$('[data-dropdown]').forEach(function (dd) {
    var b = dd.querySelector('button');
    b.addEventListener('click', function () {
      var open = dd.classList.toggle('is-open'); b.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', function (e) { if (!dd.contains(e.target)) { dd.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); } });
  });

  /* ---------- scroller arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll]'); if (!b) return;
    var sec = b.closest('.section') || document;
    var sc = sec.querySelector('[data-scroller]'); if (!sc) return;
    var dir = parseInt(b.getAttribute('data-scroll'), 10) * (isRTL ? -1 : 1);
    sc.scrollBy({ left: dir * sc.clientWidth * 0.85, behavior: 'smooth' });
  });

  /* ---------- hero slider ---------- */
  $$('.hero--slider').forEach(function (hero) {
    var track = hero.querySelector('[data-slider-track]');
    var dots = $$('[data-slider-dots] button', hero);
    var n = dots.length, i = 0, timer;
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (isRTL ? i * 100 : -i * 100) + '%)';
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }
    function play() { if (hero.getAttribute('data-autoplay') === 'true') { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, 6000); } }
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { go(i + ((dx < 0) !== isRTL ? 1 : -1)); play(); }
    });
    play();
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var input = b.parentElement.querySelector('input'); if (!input) return;
    var v = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) {
      var form = e.target.form; clearTimeout(form._t);
      form._t = setTimeout(function () {
        var b = form.querySelector('.js-update-btn'); if (b) b.click(); else form.submit();
      }, 500);
    }
  });

  /* ---------- cart ---------- */
  function refreshCart(open) {
    return fetch(rootUrl('/?sections=cart-drawer'))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawer'), cur = $('#CartDrawer');
        if (fresh && cur) {
          var wasOpen = cur.classList.contains('is-open');
          cur.innerHTML = fresh.innerHTML;
          if (wasOpen) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); }
        }
        var meta = doc.querySelector('.js-cart-data');
        if (meta) {
          var count = meta.getAttribute('data-count');
          $$('.js-cart-count').forEach(function (el) { el.textContent = count; el.hidden = count === '0'; });
          $$('.js-cart-total').forEach(function (el) { el.innerHTML = meta.getAttribute('data-total'); });
        }
        if (open) openDrawer('CartDrawer');
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('js-product-form')) return;
    if (e.submitter && e.submitter.classList.contains('shopify-payment-button__button')) return;
    if (T.cartType === 'page') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.j.description || res.j.message || T.strings.error); return; }
        var inst = form.querySelector('[data-install-variant]:checked');
        var extra = inst ? fetch((T.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(inst.getAttribute('data-install-variant'), 10), quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1 }] })
        }).catch(function () {}) : Promise.resolve();
        toast(T.strings.added);
        return extra.then(function () { return refreshCart(true); });
      })
      .catch(function () { toast(T.strings.error); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.js-line-qty'); if (!b) return;
    e.preventDefault();
    var panel = b.closest('.cart-drawer'); if (panel) panel.classList.add('is-loading');
    fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    }).then(function () { return refreshCart(false); })
      .catch(function () { toast(T.strings.error); });
  });

  /* ---------- product page: variants & gallery ---------- */
  $$('[data-product-root]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]'); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('.product-form');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var stockEl = root.querySelector('[data-stock]');
    var gallery = root.querySelector('[data-gallery]');
    var thumbs = $$('[data-thumb]', root);
    var fmt = function (cents) {
      var f = T.moneyFormat || '{{amount}}';
      var n = cents / 100;
      var withSep = function (d, s, dec) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, s); return p.join(dec); };
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return withSep(0, ',', '.');
        if (k === 'amount_with_comma_separator') return withSep(2, '.', ',');
        if (k === 'amount_no_decimals_with_comma_separator') return withSep(0, '.', ',');
        return withSep(2, ',', '.');
      }).replace(/<[^>]*>/g, '');
    };

    function showMedia(id) {
      if (!gallery || !id) return;
      var slide = gallery.querySelector('[data-media-id="' + id + '"]'); if (!slide) return;
      gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    if (gallery) {
      gallery.addEventListener('scroll', function () {
        clearTimeout(gallery._t);
        gallery._t = setTimeout(function () {
          var idx = Math.round(Math.abs(gallery.scrollLeft) / gallery.clientWidth);
          var s = gallery.children[idx];
          if (s) thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == s.getAttribute('data-media-id')); });
        }, 80);
      }, { passive: true });
    }

    if (!form) return;
    var fieldsets = $$('fieldset[data-option-index]', form);
    function selected() { return fieldsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function update() {
      var opts = selected();
      fieldsets.forEach(function (fs, i) { var o = fs.querySelector('[data-option-value]'); if (o) o.textContent = opts[i]; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      // mark unavailable combos
      fieldsets.forEach(function (fs, i) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var m = product.variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
          inp.closest('.pill').classList.toggle('is-unavailable', !m || !m.available);
        });
      });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? T.strings.addToCart : T.strings.soldOut;
      if (priceEl) {
        var html = '<span class="price__current">' + fmt(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += '<s class="price__compare">' + fmt(v.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', !!(v.compare_at_price && v.compare_at_price > v.price));
      }
      if (stockEl) {
        stockEl.className = 'stock ' + (v.available ? 'stock--in' : 'stock--out');
        stockEl.innerHTML = v.available
          ? '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg> ' + stockEl.getAttribute('data-in')
          : stockEl.getAttribute('data-out');
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (fieldsets.length) { form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option-') === 0) update(); }); update(); }
  });

  /* ---------- collection filters & sorting ---------- */
  var sortSel = $('[data-sort-select]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSel.value); url.searchParams.delete('page');
    window.location.href = url.toString();
  });
  var ff = $('[data-filter-form]');
  if (ff) {
    ff.addEventListener('submit', function (e) {
      e.preventDefault();
      var params = new URLSearchParams(new FormData(ff));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      window.location.search = params.toString();
    });
    if (window.matchMedia('(min-width: 990px)').matches) {
      ff.addEventListener('change', function (e) { if (e.target.type === 'checkbox') ff.requestSubmit ? ff.requestSubmit() : ff.submit(); });
    }
  }

  /* ---------- product recommendations ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  });


  /* description images: fill width + load full-size originals */
  document.querySelectorAll('.product__description .rte img').forEach(function (img) {
    var mark = function () { if (img.naturalWidth >= 200) img.classList.add('is-wide'); };
    var src = img.getAttribute('src') || '';
    var full = src.replace(/-\d{2,4}x\d{2,4}(?=\.(?:jpe?g|png|webp)(?:\?|$))/i, '');
    if (full !== src) {
      var probe = new Image();
      probe.onload = function () { img.src = full; img.classList.add('is-wide'); };
      probe.src = full;
    }
    if (img.complete) mark(); else img.addEventListener('load', mark);
  });
  /* ---------- wishlist / compare / recently viewed ---------- */
  var S = T.strings || {};
  var R = T.routes || {};
  var Store = {
    get: function (k) { try { var v = JSON.parse(localStorage.getItem('smarty:' + k)); return Array.isArray(v) ? v : []; } catch (e) { return []; } },
    set: function (k, v) { try { localStorage.setItem('smarty:' + k, JSON.stringify(v)); } catch (e) {} }
  };
  function cmpList() { return Store.get('compare').filter(function (x) { return x && x.h; }); }
  function cmpHas(list, h) { return list.some(function (x) { return x.h === h; }); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }

  function syncLists() {
    var w = Store.get('wishlist'), c = cmpList();
    $$('[data-wish]').forEach(function (b) {
      var on = w.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-label]'); if (l) l.textContent = on ? S.wishRemove : S.wishAdd;
      if (!l) b.setAttribute('aria-label', on ? S.wishRemove : S.wishAdd);
    });
    $$('[data-compare]').forEach(function (b) {
      var on = cmpHas(c, b.getAttribute('data-compare'));
      b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = b.querySelector('[data-label]'); if (l) l.textContent = on ? S.compareRemove : S.compareAdd;
      if (!l) b.setAttribute('aria-label', on ? S.compareRemove : S.compareAdd);
    });
    $$('.js-wish-count').forEach(function (el) { el.textContent = w.length; el.hidden = !w.length; });
    var bar = $('[data-compare-bar]');
    if (bar) {
      var show = c.length > 0 && !$('[data-compare-page]');
      bar.hidden = !show; document.body.classList.toggle('has-compare-bar', show);
      var cnt = bar.querySelector('[data-compare-count]'); if (cnt) cnt.textContent = c.length;
      var th = bar.querySelector('[data-compare-thumbs]');
      if (th) th.innerHTML = c.map(function (x) {
        return '<span class="compare-bar__thumb" title="' + esc(x.t) + '">' + (x.i ? '<img src="' + esc(x.i) + '" alt="">' : '') +
          '<button type="button" data-compare-remove="' + esc(x.h) + '" aria-label="' + esc(S.compareRemoved) + '">&times;</button></span>';
      }).join('');
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-wish'), w = Store.get('wishlist'), i = w.indexOf(h);
      if (i > -1) { w.splice(i, 1); toast(S.wishRemoved); } else { w.unshift(h); toast(S.wishAdded); }
      Store.set('wishlist', w.slice(0, 60)); syncLists();
      if (i > -1 && b.closest('[data-wishlist-grid]')) {
        var card = b.closest('.product-card'); if (card) card.remove();
        if (!Store.get('wishlist').length) { var em = $('[data-list-empty]'); if (em) em.hidden = false; }
      }
      return;
    }
    var c = e.target.closest('[data-compare]');
    if (c) {
      e.preventDefault();
      var hc = c.getAttribute('data-compare'), list = cmpList();
      if (cmpHas(list, hc)) { list = list.filter(function (x) { return x.h !== hc; }); toast(S.compareRemoved); }
      else if (list.length >= 4) { toast(S.compareMax); return; }
      else { list.push({ h: hc, i: c.getAttribute('data-img') || '', t: c.getAttribute('data-title') || '' }); toast(S.compareAdded); }
      Store.set('compare', list); syncLists(); return;
    }
    var r = e.target.closest('[data-compare-remove]');
    if (r) {
      e.preventDefault();
      var hr = r.getAttribute('data-compare-remove');
      Store.set('compare', cmpList().filter(function (x) { return x.h !== hr; }));
      var col = $('[data-compare-table] .cmp-col[data-handle="' + hr + '"]'); if (col) col.remove();
      if (!cmpList().length && $('[data-compare-page]')) { var wr = $('[data-compare-wrap]'); if (wr) wr.hidden = true; var em2 = $('[data-list-empty]'); if (em2) em2.hidden = false; }
      syncLists(); return;
    }
    if (e.target.closest('[data-compare-clear]')) { Store.set('compare', []); syncLists(); }
  });
  window.addEventListener('storage', function (e) { if (e.key && e.key.indexOf('smarty:') === 0) syncLists(); });

  function fetchSection(handle, sectionId) {
    return fetch(rootUrl('/products/' + encodeURIComponent(handle) + '?section_id=' + sectionId))
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); return d.querySelector('.shopify-section') || d.body; })
      .catch(function () { return null; });
  }
  function loadCards(handles, target, sectionId, pick) {
    return Promise.all(handles.map(function (h) { return fetchSection(h, sectionId); })).then(function (nodes) {
      var shown = 0;
      nodes.forEach(function (n) { var el = n && n.querySelector(pick); if (el) { target.appendChild(el); shown++; } });
      return shown;
    });
  }
  function doneLoading(root, shown) {
    var ld = root.querySelector('[data-list-loading]'); if (ld) ld.remove();
    var em = root.querySelector('[data-list-empty]'); if (em) em.hidden = shown > 0;
    syncLists();
  }

  var wp = $('[data-wishlist-page]');
  if (wp) {
    var wl = Store.get('wishlist');
    if (!wl.length) doneLoading(wp, 0);
    else loadCards(wl, wp.querySelector('[data-wishlist-grid]'), 'product-card-ajax', '.product-card').then(function (n) { doneLoading(wp, n); });
  }

  var cp = $('[data-compare-page]');
  if (cp) {
    var cl = cmpList().map(function (x) { return x.h; });
    if (!cl.length) doneLoading(cp, 0);
    else loadCards(cl, cp.querySelector('[data-compare-table]'), 'product-compare-col', '.cmp-col').then(function (n) {
      cp.querySelector('[data-compare-wrap]').hidden = n === 0;
      cp.querySelector('[data-compare-table]').style.setProperty('--cols', n);
      doneLoading(cp, n);
    });
  }

  $$('[data-recently-viewed]').forEach(function (sec) {
    var cur = sec.getAttribute('data-current');
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 8;
    var rv = Store.get('recent').filter(function (h) { return h !== cur; }).slice(0, limit);
    if (rv.length) loadCards(rv, sec.querySelector('[data-rv-list]'), 'product-card-ajax', '.product-card').then(function (n) { sec.hidden = n === 0; syncLists(); });
  });
  var pj = $('[data-product-root] [data-product-json]');
  if (pj) {
    try {
      var ph = JSON.parse(pj.textContent).handle;
      var rec = Store.get('recent').filter(function (h) { return h !== ph; }); rec.unshift(ph);
      Store.set('recent', rec.slice(0, 20));
    } catch (e) {}
  }

  /* installation request: prefill product, min date */
  var ip = $('[data-install-product]');
  if (ip) { var q = new URLSearchParams(location.search).get('product'); if (q && !ip.value) ip.value = q; }
  $$('[data-min-today]').forEach(function (d) { var t = new Date(); t.setMinutes(t.getMinutes() - t.getTimezoneOffset()); d.min = t.toISOString().slice(0, 10); });

  syncLists();
  /* ---------- homepage: hotspots, tabs, countdown ---------- */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('.hs-dot');
    $$('.hs-spot.is-open').forEach(function (sp) { if (!dot || sp !== dot.parentElement) { sp.classList.remove('is-open'); sp.querySelector('.hs-dot').setAttribute('aria-expanded', 'false'); } });
    if (dot) { var sp = dot.parentElement; var o = sp.classList.toggle('is-open'); dot.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    var tab = e.target.closest('[data-tab]');
    if (tab) {
      var root = tab.closest('[data-tabs]');
      $$('[data-tab]', root).forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('[data-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== tab.getAttribute('data-tab'); });
    }
  });
  $$('[data-hotspots]').forEach(function (h) { var first = h.querySelector('.hs-spot'); if (first && window.matchMedia('(min-width: 750px)').matches) { first.classList.add('is-open'); first.querySelector('.hs-dot').setAttribute('aria-expanded', 'true'); } });
  $$('[data-deals]').forEach(function (sec) {
    var raw = sec.getAttribute('data-end'); if (!raw) return;
    if (!/[+-]\d\d:?\d\d$|Z$/.test(raw)) raw += (raw.length <= 16 ? ':00' : '') + '+03:00';
    var end = new Date(raw).getTime(); if (isNaN(end)) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var d = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (d === 0 && sec.getAttribute('data-hide-ended') === 'true') { sec.hidden = true; return; }
      $$('[data-countdown]', sec).forEach(function (c) {
        c.querySelector('[data-d]').textContent = pad(Math.floor(d / 86400));
        c.querySelector('[data-h]').textContent = pad(Math.floor(d % 86400 / 3600));
        c.querySelector('[data-m]').textContent = pad(Math.floor(d % 3600 / 60));
        c.querySelector('[data-s]').textContent = pad(d % 60);
      });
      if (d > 0) setTimeout(tick, 1000);
    }
    tick();
  });
  /* ---------- smart lock quiz ---------- */
  $$('[data-lock-quiz]').forEach(function (root) {
    var data = []; var S = {};
    try { data = JSON.parse(root.querySelector('[data-lq-products]').textContent); S = JSON.parse(root.querySelector('[data-lq-strings]').textContent); } catch (e) { return; }
    var ans = { door: null, methods: [], budget: null };
    function show(n) {
      $$('[data-step]', root).forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') == n); });
      if (n == 4) render();
    }
    function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.lq__opts button');
      if (opt) {
        var step = opt.closest('[data-step]'), key = step.getAttribute('data-key'), val = opt.getAttribute('data-val');
        if (step.hasAttribute('data-multi')) {
          opt.classList.toggle('is-on');
          ans[key] = $$('.lq__opts button.is-on', step).map(function (b) { return b.getAttribute('data-val'); });
          step.querySelector('.lq__next').disabled = !ans[key].length;
        } else {
          $$('.lq__opts button', step).forEach(function (b) { b.classList.toggle('is-on', b === opt); });
          ans[key] = val; step.querySelector('.lq__next').disabled = false;
          setTimeout(function () { show(parseInt(step.getAttribute('data-step'), 10) + 1); }, 220);
        }
        return;
      }
      var go = e.target.closest('[data-go]');
      if (go && !go.disabled) { show(go.getAttribute('data-go')); return; }
      if (e.target.closest('[data-restart]')) {
        ans = { door: null, methods: [], budget: null };
        $$('.lq__opts button', root).forEach(function (b) { b.classList.remove('is-on'); });
        $$('.lq__next', root).forEach(function (b) { b.disabled = true; });
        show(1);
      }
    });
    function render() {
      var lo = 0, hi = 99999; if (ans.budget) { var p = ans.budget.split('-'); lo = +p[0]; hi = +p[1]; }
      var scored = data.map(function (x) {
        var doors = x.d.split(',').filter(Boolean), ms = x.m.split(',').filter(Boolean), price = x.p / 100;
        var doorOk = !ans.door || doors.indexOf(ans.door) > -1;
        var hits = ans.methods.filter(function (m) { return ms.indexOf(m) > -1; });
        var inB = price >= lo && price <= hi, over = price > hi ? (price - hi) : 0;
        var score = (doorOk ? 100 : 0) + hits.length * 10 + (inB ? 30 : (over && over <= hi * 0.25 ? 12 : 0)) - (inB ? 0 : Math.min(over, 200) / 10) + x.f;
        return { x: x, doorOk: doorOk, hits: hits, inB: inB, over: over, score: score };
      }).filter(function (r) { return r.doorOk; }).sort(function (a, b) { return b.score - a.score || a.x.p - b.x.p; });
      var exact = scored.filter(function (r) { return r.inB && r.hits.length === ans.methods.length; }).length;
      var top = scored.slice(0, 3);
      var chosen = [ans.door].concat(ans.methods, [ans.budget]).filter(Boolean).map(function (k) { return '<span>' + esc(S.labels[k] || k) + '</span>'; }).join('');
      root.querySelector('[data-chosen]').innerHTML = chosen;
      var html = (!exact ? '<p class="lq__none">' + esc(S.none) + '</p>' : '') + top.map(function (r, i) {
        var x = r.x;
        var ticks = r.hits.map(function (m) { return '✓ ' + esc(S.labels[m]); }).join(' · ');
        var btn = x.v ? '<form method="post" action="' + ((window.theme && theme.routes.cartAdd) || '/cart/add') + '" class="js-product-form"><input type="hidden" name="id" value="' + x.v + '"><button type="submit" class="lq__add">' + esc(S.add) + '</button></form>'
                      : '<a class="lq__add" href="' + x.u + '">' + esc(S.options) + '</a>';
        return '<div class="lq__res' + (i === 0 ? ' is-best' : '') + '">' + (i === 0 ? '<span class="lq__best">' + esc(S.best) + '</span>' : '') +
          '<a href="' + x.u + '" class="lq__img">' + (x.i ? '<img src="' + x.i + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="lq__info"><a href="' + x.u + '" class="lq__name">' + esc(x.t) + '</a>' + (ticks ? '<small class="lq__ticks">' + ticks + '</small>' : '') +
          '<span class="lq__price">' + esc(x.pf) + '</span>' + (!r.inB ? '<small class="lq__over">' + esc(S.above) + '</small>' : '') + btn + '</div></div>';
      }).join('');
      root.querySelector('[data-results]').innerHTML = html;
    }
  });
  /* ---------- live search ---------- */
  (function () {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var cache = {};
    function variants(q) {
      var t = q.trim(), v = [t];
      var m = t.match(/^([a-z]{2,4})[\s-]?(\d{1,4})([a-z]{0,3})$/i);
      if (!m) return v;
      var L = m[1], D = m[2], S = m[3] || '';
      function add(x) { if (v.indexOf(x) < 0) v.push(x); }
      add(L + '-' + D + S); add(L + D + S);
      if (D.length < 3) { var P = ('000' + D).slice(-3); add(L + '-' + P + S); add(L + P + S); }
      return v;
    }
    function searchUrl(q) { return root + 'search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); }
    function one(q) {
      return fetch(root + 'search?section_id=search-live&type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var inner = d.querySelector('.sl__inner');
          return { q: q, count: inner ? parseInt(inner.getAttribute('data-count'), 10) || 0 : 0, items: inner ? $$('.sl__item', inner) : [], inner: inner };
        }).catch(function () { return { q: q, count: 0, items: [], inner: null }; });
    }
    function lookup(q) {
      var key = q.trim().toLowerCase();
      if (cache[key]) return Promise.resolve(cache[key]);
      return Promise.all(variants(q).map(one)).then(function (res) {
        var best = null, seen = {}, list = [];
        res.forEach(function (r) {
          if (r.count && !best) best = r;
          r.items.forEach(function (a) {
            var k = (a.getAttribute('href') || '').split('?')[0];
            if (!seen[k] && list.length < 6) { seen[k] = 1; list.push(a.outerHTML); }
          });
        });
        var html;
        if (!list.length) {
          var empty = res[0].inner && res[0].inner.querySelector('.sl__empty');
          html = '<div class="sl__inner">' + (empty ? empty.outerHTML : '') + '</div>';
        } else {
          var allLink = best.inner.querySelector('.sl__all');
          if (allLink) allLink.setAttribute('href', searchUrl(best.q));
          html = '<div class="sl__inner">' + list.join('') + (allLink ? allLink.outerHTML : '') + '</div>';
        }
        cache[key] = { html: html, best: best ? best.q : q.trim() };
        return cache[key];
      });
    }
    $$('form[role="search"]').forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      form.classList.add('sl-host');
      input.setAttribute('autocomplete', 'off');
      var box = document.createElement('div');
      box.className = 'sl'; box.hidden = true; box.setAttribute('role', 'listbox');
      form.appendChild(box);
      var timer, active = -1;
      function close() { box.hidden = true; active = -1; }
      function items() { return $$('.sl__item, .sl__all', box); }
      function run() {
        var q = input.value.trim();
        if (q.length < 2) { close(); return; }
        lookup(q).then(function (r) { if (input.value.trim() === q) { box.innerHTML = r.html; box.hidden = false; active = -1; } });
      }
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
      input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
      input.addEventListener('keydown', function (e) {
        if (box.hidden) return;
        var list = items();
        if (!list.length) return;
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          active = (active + (e.key === 'ArrowDown' ? 1 : -1) + list.length) % list.length;
          list.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
          list[active].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && active > -1) {
          e.preventDefault(); location.href = list[active].href;
        } else if (e.key === 'Escape') { close(); }
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (!q || variants(q).length < 2) return;
        e.preventDefault();
        lookup(q).then(function (r) { location.href = searchUrl(r.best); });
      });
    });
  })();
})();

/* PDF brochure viewer — half-page preview with page arrows (pdf.js) */
(function () {
  var cards = document.querySelectorAll('.doc-dl');
  if (!cards.length) return;
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';
  var rtl = document.documentElement.dir === 'rtl';
  var T = rtl ? { prev: 'الصفحة السابقة', next: 'الصفحة التالية', more: 'عرض الصفحة كاملة', less: 'تصغير', load: 'جارٍ تحميل الكتيّب…', page: 'صفحة' }
              : { prev: 'Previous page', next: 'Next page', more: 'Show full page', less: 'Show less', load: 'Loading brochure…', page: 'Page' };
  var libP;
  function lib() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    return libP || (libP = new Promise(function (ok, bad) {
      var s = document.createElement('script'); s.src = CDN + 'pdf.min.js';
      s.onload = function () { pdfjsLib.GlobalWorkerOptions.workerSrc = CDN + 'pdf.worker.min.js'; ok(pdfjsLib); };
      s.onerror = bad; document.head.appendChild(s);
    }));
  }
  var arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  cards.forEach(function (card) {
    var a = card.querySelector('a.doc-dl__card'); if (!a) return;
    var url = a.getAttribute('href');
    var v = document.createElement('div');
    v.className = 'pdfv is-loading';
    v.innerHTML = '<div class="pdfv__stage"><canvas class="pdfv__canvas"></canvas><span class="pdfv__msg">' + T.load + '</span>' +
      '<button type="button" class="pdfv__nav pdfv__prev" aria-label="' + T.prev + '">' + arrow + '</button>' +
      '<button type="button" class="pdfv__nav pdfv__next" aria-label="' + T.next + '">' + arrow + '</button>' +
      '<span class="pdfv__count"></span>' +
      '<button type="button" class="pdfv__more"><span>' + T.more + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg></button></div>';
    card.insertBefore(v, card.firstChild);
    var stage = v.querySelector('.pdfv__stage'), canvas = v.querySelector('canvas'), count = v.querySelector('.pdfv__count');
    var prev = v.querySelector('.pdfv__prev'), next = v.querySelector('.pdfv__next'), more = v.querySelector('.pdfv__more');
    var doc, n = 1, busy = false, task;
    function render() {
      if (!doc) return;
      busy = true;
      doc.getPage(n).then(function (p) {
        var w = stage.clientWidth || 600, base = p.getViewport({ scale: 1 });
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var vp = p.getViewport({ scale: (w / base.width) * dpr });
        canvas.width = vp.width; canvas.height = vp.height;
        canvas.style.width = '100%';
        if (task) task.cancel();
        task = p.render({ canvasContext: canvas.getContext('2d'), viewport: vp });
        return task.promise;
      }).catch(function () {}).then(function () {
        busy = false;
        count.innerHTML = T.page + ' <bdi dir="ltr">' + n + ' / ' + doc.numPages + '</bdi>';
        prev.disabled = n <= 1; next.disabled = n >= doc.numPages;
        v.classList.remove('is-loading');
      });
    }
    function go(d) { if (!doc || busy) return; var m = n + d; if (m < 1 || m > doc.numPages) return; n = m; stage.scrollTop = 0; render(); }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    more.addEventListener('click', function () {
      var open = v.classList.toggle('is-open');
      more.querySelector('span').textContent = open ? T.less : T.more;
      if (!open) v.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) go((dx < 0) !== rtl ? 1 : -1);
    }, { passive: true });
    var rw; window.addEventListener('resize', function () { clearTimeout(rw); rw = setTimeout(render, 250); });
    function start() {
      lib().then(function (L) { return L.getDocument(url).promise; })
        .then(function (d) { doc = d; v.classList.toggle('is-single', d.numPages < 2); render(); })
        .catch(function () { v.remove(); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '400px' });
      io.observe(v);
    } else start();
  });
})();

/* product side tabs */
(function () {
  document.querySelectorAll('[data-pinfo]').forEach(function (root) {
    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var panels = [].slice.call(root.querySelectorAll('[data-panel]'));
    if (!tabs.length) return;
    // drop the heading that introduced the moved spec table
    var slot = root.querySelector('.pinfo__slot');
    if (slot) {
      var h = slot.previousElementSibling;
      if (!h && slot.parentElement && slot.parentElement.tagName !== 'DIV') { h = slot.parentElement.previousElementSibling; }
      if (h && /^H[1-4]$/.test(h.tagName)) h.remove();
      slot.remove();
    }
    function show(name, focus) {
      tabs.forEach(function (t) { var on = t.dataset.tab === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === name); if (p.dataset.panel !== name) p.querySelectorAll('video').forEach(function (v) { v.pause(); }); });
      window.dispatchEvent(new Event('resize'));
      if (focus) {
        var act = root.querySelector('[data-tab="' + name + '"]');
        if (act && act.scrollIntoView && window.innerWidth < 990) act.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.tab, true); }); });
    var start = tabs[0].dataset.tab;
    if (/contact_posted|#ReviewForm|#reviews/.test(location.href) && root.querySelector('[data-tab="reviews"]')) start = 'reviews';
    root.classList.add('is-ready');
    show(start);
    if (start === 'reviews' && /contact_posted|#ReviewForm/.test(location.href)) root.scrollIntoView({ block: 'start' });
    document.querySelectorAll('a[href="#reviews"],.product__meta .stars').forEach(function (a) {
      a.style.cursor = 'pointer';
      a.addEventListener('click', function (e) { e.preventDefault(); show('reviews'); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    });
  });
})();
